import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=6d00b852&scoped=true"
import script from "./Tasks.vue?vue&type=script&lang=ts"
export * from "./Tasks.vue?vue&type=script&lang=ts"
import style0 from "./Tasks.vue?vue&type=style&index=0&id=6d00b852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d00b852",
  null
  
)

export default component.exports